(function (skyward, $, undefined)
{
    "use strict";

    skyward.reporting = skyward.reporting || {};
    skyward.reporting.searchParameters = skyward.reporting.searchParameters || {};

    var _view = skyward.mvvm.newView(function ()
    {
        var _self = this;
        var _templates, _viewParts, _layer;

        var _internal = {
            "loadTemplates": function ()
            {
                var deferred = $.Deferred();
                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetSearchParameterBuilderTemplate/",
                    type: "POST",
                    dataType: "JSON",
                    success: async function (data)
                    {
                        const [processedBuilder, processedAvailable, processedInUse, processedDynList, processedDynItem, processedIcons] = await Promise.all([
                            skyward.global.processViewPartHtml(data.builder),
                            skyward.global.processViewPartHtml(data.availableItem),
                            skyward.global.processViewPartHtml(data.inUseItems),
                            skyward.global.processViewPartHtml(data.dynamicValueList),
                            skyward.global.processViewPartHtml(data.dynamicValueItem),
                            skyward.global.processViewPartHtml(data.icons)
                        ]);

                        _templates = {
                            builder: $(processedBuilder),
                            availableItem: $(processedAvailable),
                            inUseItems: $(processedInUse),
                            dynamicValueList: $(processedDynList),
                            dynamicValueItem: $(processedDynItem),
                            icons: $(processedIcons)
                        };

                        _templates.inUseItems.find("input").attr("tabindex", 0);

                        _templates.inUseItems.find("input").removeProp("readonly");
                        deferred.resolve(data);
                    }
                });
                return deferred;
            },
            "getIndex": function (item)
            {
                return (item.hasClass(".searchParameterItem") ? item : item.closest(".searchParameterItem")).prevAll().length;
            },
            "getIcon": function (dataType, isPrompt)
            {
                var icon;
                if (isPrompt)
                {
                    icon = _templates.icons.find(".prompt");
                }
                else
                {
                    var where_dataTypeMatches = function ()
                    {
                        if (dataType.startsWith("String Enum-"))
                        {
                            return ($(this).data("show-for") || "").split(",").findIndex(function (item)
                            {
                                return item == "String Enum-System.Enum";
                            }) !== -1;
                        }
                        return ($(this).data("show-for") || "").split(",").indexOf(dataType) !== -1;
                    };

                    icon = _templates.icons.find(".parameterIcon").filter(where_dataTypeMatches);
                    if (!icon.length)
                    {
                        icon = _templates.icons.find(".other");
                    }
                }
                icon = icon.clone();

                return icon;
            },
            "setValueOnInUseItem": function (key, value, displayValue, dataType, isPrompt, required)
            {
                var itemViewPart = _viewParts.items[key];
                var container = itemViewPart.find(".searchParameterValueContainer");
                //Remove ends up here at which point the inputs are no longer there
                if (container.length)
                {
                    var input = container.find(".value");
                    var label = container.find(".searchParameterLabel");
                    var enumIcon = container.find(".enumParameterIcon");

                    var datepicker = itemViewPart.find(".datepicker");

                    input.val(value);
                    container.toggleClass("dynamic", displayValue ? true : false).children("svg").not(".enumParameterIcon").remove();
                    if (displayValue)
                    {
                        input.hide();
                        label.empty().text(displayValue).show();
                        _internal.getIcon(dataType, isPrompt).prependTo(label);
                        if (dataType === "DateTime")
                        {
                            var datepickerButton = itemViewPart.find(".datepicker-trigger");
                            datepickerButton.hide();
                        }

                        if (enumIcon.length)
                        {
                            enumIcon.hide();
                        }
                    }
                    else
                    {
                        input.show();
                        label.hide();
                        if (dataType === "DateTime" && datepicker.length)
                        {
                            skyward.datepicker.registerDatepicker(datepicker);
                        }
                    }
                    var asterisk = _viewParts.items[key].find(".requiredAsterisk");
                    asterisk.toggle(required);
                }
            },
            "itemIsInUse": function (item) { return item.closest(".searchParameterContainer").hasClass("inUse"); }
        };

        var _events = {
            "open": function ()
            {
                if (!_templates)
                {
                    _internal.loadTemplates().then(_events.open);
                    return;
                }

                var html = _templates.builder.clone();
                var buttons = [
                    { text: "Ok", icon: "Check", click: function () { _events.save(); if (!_events.Error()) { _events.close(); } } },
                    { text: "Cancel", icon: "Cancel", click: "close" }
                ];
                _layer = skyward.modalLayer.showDialog("Search Parameter Builder", html, buttons, { afterClose: _events.close, closeOnClick: false, automationID: "parameter-builder-dialog" });

                _layer.animationPromise.then(_layer.bodyPromise).done(function ()
                {
                    _viewParts = {
                        global: _layer.content,
                        inUseList: _layer.content.find(".inUse .searchParameterList"),
                        availableList: _layer.content.find(".available .searchParameterList"),
                        items: {},
                        actions: _layer.content.find(".searchParameterContainer.actions"),
                        addButton: _layer.content.find(".add"),
                        removeButton: _layer.content.find(".remove")
                    };

                    _viewParts.inUseList.on("change", ".value", null, _events.inputChanged);

                    _viewParts.inUseList.on("click", ".searchParameterItem", null, _events.inUseItemClicked);
                    _viewParts.availableList.on("click", ".searchParameterItem", null, _events.availableItemClicked);

                    _viewParts.actions.on("click", ".add", null, _events.addClicked);
                    _viewParts.availableList.on("dblclick", ".searchParameterItem", null, _events.addClicked);

                    _viewParts.actions.on("click", ".remove", null, _events.removeClicked);
                    _viewParts.inUseList.on("dblclick", ".searchParameterItem", null, _events.removeClicked);

                    _viewParts.global.on("click", ".selectValue", null, _events.valueSelectorClicked);

                    _self.announce('open');
                });
            },
            "close": function ()
            {
                if (_layer && _layer.modalLayer.onscreen)
                {
                    _layer.close();
                }

                $.each(_viewParts, function () { $(this).off(); });
                _viewParts = {};
                _self.announce('close');
            },
            "save": function ()
            {
                _self.announce('save');
            },
            "addClicked": function ()
            {
                _self.announce('add');
            },
            "removeClicked": function ()
            {
                _self.announce('remove');
            },
            "inUseItemClicked": function ()
            {
                _self.announce('select', true, _internal.getIndex($(this)));
            },
            "availableItemClicked": function ()
            {
                _self.announce('select', false, _internal.getIndex($(this)));
            },
            "inputChanged": function (event)
            {
                var item = $(this);
                var inUse = item.closest(".searchParameterContainer").hasClass("inUse");
                var value = $(event.target).val();
                _self.announce('change', inUse, _internal.getIndex(item), value);
            },
            "valueSelectorClicked": function ()
            {
                _self.announce("dynamicValues", _internal.getIndex($(this)));
            },
            "dynamicValueSelected": function (data)
            {
                _self.announce('change', true, _internal.getIndex(data.item), data.value, data.displayValue, data.displayValueType);
                var datePickerIcon = data.item.find(".datepicker-trigger");
                if (datePickerIcon.length)
                {
                    if (data.value === "")
                    {
                        datePickerIcon.show();
                    }
                    else
                    {
                        datePickerIcon.hide();
                    }
                }

                data.item.find("input:visible").focus();
            },
            "Error": function ()
            {
                var errors = skyward.reporting.searchParameters.viewModel.getErrors();
                if (!$.isEmptyObject(errors))
                {
                    skyward.validation.displayValidationMessages({ errors: errors }, _layer.content, $());
                    return true;
                }
                return false;
            }

        };

        var actions = {
            "init": function ()
            {
                $(".jsSearchParameterBuilder").on("click", _events.open);
                return _self;
            },
            "nothingToShow": function ()
            {
                const buttons = [{ text: "Close", icon: "Close", click: "close" }];
                skyward.modalLayer.showInformationDialog("No Parameters Available", "No fields that accept parameters are currently used in this report.", buttons, { afterClose: _events.close });
            },
            "invalidSearchParameters": function (keys)
            {
                var messageParts = ["The following parameters are no longer accepted by any of the fields used in this report:", ""];
                messageParts = messageParts.concat(keys);
                messageParts = messageParts.concat(["", "These parameters have been automatically removed."]);
                var message = messageParts.join('\n');

                skyward.modalLayer.showInformationDialog("Invalid Parameters", message);
            },
            "add": function (addToInUseList, key, value, displayValue, dataType, isPrompt, required)
            {
                var isEnum = dataType.startsWith("String Enum-");

                var where_dataTypeMatches = function ()
                {
                    if (isEnum)
                    {
                        return ($(this).data("show-for") || "").split(",").indexOf("String Enum-") !== -1;
                    }
                    return ($(this).data("show-for") || "").split(",").indexOf(dataType) !== -1;
                };

                var where_defaultDataType = function ()
                {
                    return ($(this).data("show-for") || "").indexOf("Default") !== -1;
                };

                var item;
                if (addToInUseList)
                {
                    item = _templates.inUseItems.filter(where_dataTypeMatches);
                    if (item.length === 0)
                    {
                        item = _templates.inUseItems.filter(where_defaultDataType);
                    }
                    item = item.first().clone();
                    var asterisk = item.find(".requiredAsterisk");
                    item.find(".key").text(key).prepend(asterisk).data("dataType", dataType);
                    item.find(".searchParameterLabel").attr("data-validate-text-for", key);
                    item.find(".value").attr("data-validate-control-for", key);
                    item.find(".error").attr("data-validate-message-for", key);

                    const dateTimePickers = item.find(".dateTimePickerWrapper");
                    if (dateTimePickers.length > 0)
                    {
                        dateTimePickers.attr("data-suppress-focus", "true");
                    }

                    _viewParts.inUseList.append(item);
                }
                else
                {
                    item = _templates.availableItem.clone();
                    item.find(".key").text(key);
                    _viewParts.availableList.append(item);
                }
                skyward.window.notifyDOMLoad(item);

                // Track item viewparts by key
                (_viewParts.items = _viewParts.items || {})[key] = item;

                // Set values and icon
                if (addToInUseList)
                {
                    _internal.setValueOnInUseItem(key, value, displayValue, dataType, isPrompt, required);
                }
                else
                {
                    item.find(".parameterIcon").remove();
                    item.prepend(_internal.getIcon(dataType, isPrompt));
                }
            },
            "remove": function (key)
            {
                _viewParts.items[key].remove();
                delete _viewParts.items[key];
            },
            "select": function (key)
            {
                const input = _viewParts.items[key].addClass("selectedSearchParameter").find("input:visible");
                if (input.closest(".dateTimePickerWrapper").length > 0)
                {
                    input.attr("data-suppress-focus", "true");
                }
                input.focus();
                (_internal.itemIsInUse(_viewParts.items[key]) ? _viewParts.removeButton : _viewParts.addButton).show();
            },
            "unselect": function (key)
            {
                _viewParts.items[key].removeClass("selectedSearchParameter");
                (_internal.itemIsInUse(_viewParts.items[key]) ? _viewParts.removeButton : _viewParts.addButton).hide();
            },
            "change": _internal.setValueOnInUseItem,
            "showDynamicValues": function (searchParameterModel, prompts, environmentValues, enumOptions)
            {
                var key = searchParameterModel.key;
                var dataType = searchParameterModel.dataType;
                var required = searchParameterModel.required;
                var defaultFieldPath = searchParameterModel.defaultFieldPath;

                // This is *not* MVVM - it puts too much responsibility in the view, and there's no model to represent a dynamic value or the collection of DVs.
                // A separate viewModel should be created to handle selecting dynamic values.
                // Then we can use one viewModel-type everywhere dynamic values need to be displayed and chosen.
                var deferred = $.Deferred();
                deferred.done(_events.dynamicValueSelected);

                var searchParameter = _viewParts.items[key];
                var content = _templates.dynamicValueList.clone();

                var lastEnumItem = content.find(".enumValues");
                if (Object.keys(enumOptions).length)
                {
                    var staticValue = content.find(".staticValue");
                    staticValue.hide();
                    $.each(enumOptions, function (displayValue, value)
                    {
                        var nextEnumItem = _templates.dynamicValueItem.clone();
                        nextEnumItem.on("click", function () { deferred.resolve({ item: searchParameter, value: value, displayValue: displayValue }); });
                        nextEnumItem.find(".searchParameterLabel").text(displayValue);
                        nextEnumItem.find(".iconTarget").append(_internal.getIcon(dataType));
                        lastEnumItem = nextEnumItem.insertAfter(lastEnumItem);
                    });
                }
                else
                {
                    lastEnumItem.hide();
                }

                var lastEnvironmentItem = content.find(".environment");
                if (Object.keys(environmentValues).length)
                {
                    $.each(environmentValues, function (displayValue, value)
                    {
                        var nextEnvironmentItem = _templates.dynamicValueItem.clone();
                        nextEnvironmentItem.on("click", function () { deferred.resolve({ item: searchParameter, value: value, displayValue: displayValue }); });
                        nextEnvironmentItem.find(".searchParameterLabel").text(displayValue);
                        nextEnvironmentItem.find(".iconTarget").append(_internal.getIcon(dataType));
                        lastEnvironmentItem = nextEnvironmentItem.insertAfter(lastEnvironmentItem);
                    });
                }
                else
                {
                    _templates.dynamicValueItem.clone()
                        .insertAfter(lastEnvironmentItem)
                        .find(".searchParameterLabel").text("No environment variables are available for this parameter");
                }


                var lastPromptItem = content.find(".prompts");
                $.each(prompts || {}, function ()
                {
                    var prompt = this;
                    var nextPromptItem = _templates.dynamicValueItem.clone();
                    nextPromptItem.on("click", function ()
                    {
                        if (required)
                        {
                            prompt.PresenceType = "Required";
                        }
                        deferred.resolve({ item: searchParameter, value: prompt.bindingString(), displayValue: prompt.Label });
                    });
                    nextPromptItem.find(".searchParameterLabel").text(prompt.Label);
                    nextPromptItem.find(".iconTarget").append(_internal.getIcon(dataType, true));
                    lastPromptItem = nextPromptItem.insertAfter(lastPromptItem);
                });

                content.find(".staticValue").on("click", function ()
                {
                    deferred.resolve({ item: searchParameter, value: "" });
                });

                // This nested-callback madness is exactly the kind of stuff that we'll avoid if we can fully implement MVVM
                content.find(".addPrompt").on("click", function ()
                {
                    const promptInfo = { Label: key, InputType: dataType, FieldPath: defaultFieldPath };
                    const parameter = skyward.reporting.currentReportDefinition.AvailableParameters[key];
                    const promptOptions = { treatPromptAsInUse: true, treatPromptAsInUseRequired: required, tempRelatedSearchParameter: parameter };

                    if (parameter.isList === true)
                    {
                        promptInfo.Type = skyward.reporting.enummaps.PromptTypes.MultipleSelect;
                    }

                    const addPromptView = skyward.reporting.prompts.getPromptDetailsView(promptInfo, promptOptions);

                    addPromptView.then(function (data)
                    {
                        deferred.resolve(data && data.promptModel ? { item: searchParameter, value: data.promptModel.bindingString(), displayValue: data.promptModel.Label } : undefined);
                    });
                });

                var popup = skyward.modalLayer.showInformationDialog("Select A Dynamic Value", content, null, {
                    closeOnClick: true,
                    afterClose: function ()
                    {
                        if (deferred.state() !== "resolved")
                        {
                            deferred.reject();
                        }
                    },
                    warning: true
                });
                deferred.done(function () { if (popup && typeof (popup.close === "function")) { popup.close(); } });
            },
            "Validate": function ()
            {
                return _events.Error();
            }
        };
        return actions;
    });

    skyward.reporting.searchParameters.viewModel = skyward.mvvm.newViewModel(function ()
    {
        var _self = this;
        var _availableModel, _savedModel, _unsavedModel, _viewState;

        var _internal = {
            "loadAvailableItems": function ()
            {
                var parameters = skyward.reporting.currentReportDefinition.AvailableParameters;
                for (var key in parameters)
                {
                    var searchParameter = parameters[key];
                    if (!_unsavedModel.some(function (sp) { return sp.key === key; }))
                    {
                        if (searchParameter.required)
                        {
                            _unsavedModel.add(skyward.mvvm.newModel({ value: "", dataType: searchParameter.dataType, required: searchParameter.required, defaultFieldPath: searchParameter.defaultFieldPath, isList: searchParameter.isList }, { key: key }));
                        }
                        else
                        {
                            _availableModel.add(skyward.mvvm.newModel({ value: "", dataType: searchParameter.dataType, required: searchParameter.required, defaultFieldPath: searchParameter.defaultFieldPath, isList: searchParameter.isList }, { key: key }));
                        }
                    }

                    var searchParametersWithWrongRequired = _unsavedModel.filter(function (sp) { return sp.key === key && sp.required !== searchParameter.required; });

                    $.each(searchParametersWithWrongRequired, function (index, value)
                    {
                        value.required = searchParameter.required;
                    });
                }

                if (_availableModel.length)
                {
                    _viewState.selected = _availableModel.elementAt(0);
                }
                else if (!_unsavedModel.length)
                {
                    _view.nothingToShow();
                }

                // Find and remove invalid parameters
                var invalidSearchParameters = _unsavedModel.findMany(function (sp, existingKeys) { return !existingKeys[sp.key]; }, parameters);
                if (invalidSearchParameters.length)
                {
                    var keys = [];
                    invalidSearchParameters.forEach(function (sp) { _unsavedModel.remove(sp); keys.push(sp.key); });
                    _view.invalidSearchParameters(keys);
                }
            },
            "makeSearchParameterCollection": function (originalItems)
            {
                var _thisCollection;
                var actions = {
                    "inUseToJson": function (parameters)
                    {
                        var result = [];
                        _thisCollection.forEach(function (sp)
                        {
                            if (parameters.hasOwnProperty(sp.key))
                            {
                                var spJson = { key: sp.key + "", value: sp.value + "", required: sp.required, isList: sp.isList };
                                if (sp.dataType !== undefined)
                                {
                                    spJson.dataType = sp.dataType;
                                }

                                result.push(spJson);
                            }
                            else
                            {
                                _thisCollection.remove(sp);
                            }
                        });
                        return result;
                    }
                };
                _thisCollection = skyward.mvvm.newModelCollection(originalItems, { massUpdateInProgress: false }, actions);
                return _thisCollection;
            },
            "makeSearchParameter": function (data)
            {
                let value = data.value ? data.value : data.Value;
                let required = data.required ? data.required : data.Required;
                let dataType = data.dataType ? data.dataType : data.DataType;
                let key = data.key ? data.key : data.Key;
                let displayValue = data.displayValue ? data.displayValue : data.DisplayValue;
                let isList = data.isList ? data.isList : data.IsList;

                if (!dataType.startsWith("String Enum-"))
                {
                    displayValue = skyward.reporting.enummaps.EnvironmentVariableBindingToDisplayValue[value];
                }

                const model = skyward.mvvm.newModel({ value: value, required: required }, { dataType: dataType, key: key });
                model.displayValue = displayValue; // We don't track this value, or it breaks dirty logic
                model.defaultFieldPath = data.defaultFieldPath;
                model.isList = isList;
                return model;
            },
            "cloneSearchParameter": function (sp)
            {
                return skyward.mvvm.newModel({ value: sp.value, displayValue: sp.displayValue, required: sp.required, defaultFieldPath: sp.defaultFieldPath, isList: sp.isList }, { dataType: sp.dataType, key: sp.key });
            },
            "isPrompt": function (value)
            {
                return value.substring(0, 9) === "{_prompt.";
            },
            "updatePromptDisplayValues": function (uniqueId, newDisplayValue)
            {
                var searchString = "{_prompt." + uniqueId + "}";
                var where_ParameterReferencesPrompt = function (sp) { return sp.value === searchString; };
                var update = function () { if (this.displayValue !== newDisplayValue) { this.displayValue = newDisplayValue; } };

                $.each(_savedModel.findMany(where_ParameterReferencesPrompt), update);
                if (_unsavedModel)
                {
                    $.each(_unsavedModel.findMany(where_ParameterReferencesPrompt), update);
                }
            },
            "removePromptReferences": function (uniqueId)
            {
                var searchString = "{_prompt." + uniqueId + "}";
                var where_ParameterReferencesPrompt = function (sp) { return sp.value === searchString; };
                var reset = function () { this.value = ""; this.displayValue = ""; };

                $.each(_savedModel.findMany(where_ParameterReferencesPrompt), reset);
                if (_unsavedModel)
                {
                    $.each(_unsavedModel.findMany(where_ParameterReferencesPrompt), reset);
                }
            },
            "validateValue": function (parameter)
            {
                let value = parameter.value;
                let valid = true;
                let message = "";
                if (!value.startsWith("{_"))
                {
                    if (parameter.isList)
                    {
                        valid = false;
                        message = "This parameter requires a List Type Environment Variable or Prompt."
                    }
                    else if (value === "")
                    {
                        valid = false;
                        message = "A value is required.";
                    }
                    else
                    {
                        switch (parameter.dataType)
                        {
                            case "Number Long":
                                /* Unable to use a value of 9223372036854775807 when the parameter type is Number Long, since we don't support using BigInt yet due to old versions of Safari on older iOS devices.
                                 * To get around this limitation we are masking the search condition value to at most 18 characters instead of 19, which guaranties the input is a valid long and we can skip the range validation.
                                 * See PR 5271305
                                 */
                                valid = skyward.validation.validNumber(value);
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Long.`;
                                }
                                break;
                            case "Number Int":
                                valid = skyward.validation.validNumber(value) && Number(value) >= -2147483648 && Number(value) <= 2147483647;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Int.`;
                                }
                                break;
                            case "Number Short":
                                valid = skyward.validation.validNumber(value) && Number(value) >= -32768 && Number(value) <= 32767;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Short.`;
                                }
                                break;
                            case "Number Byte":
                                valid = skyward.validation.validNumber(value) && Number(value) >= 0 && Number(value) <= 255;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Byte.`;
                                }
                                break;
                            case "DateTime":
                                let date = skyward.datepicker.parseDateString(value);
                                valid = skyward.time.isDate(date);
                                if (!valid)
                                {
                                    message = `'${value}' is not a valid Date.`;
                                }
                                break;
                        }
                    }
                }

                return { isValid: valid, errorMessage: message };
            }
        };

        var _events = {
            viewState: {
                "selected": function (item, oldItem)
                {
                    if (oldItem)
                    {
                        _view.unselect(oldItem.key);
                    }

                    if (item && !item.required)
                    {
                        _view.select(item.key);
                    }
                }
            },
            model: {
                "contentChanged": function (item) //, announcement)
                // a callback for a contentChanged event can receive the item's announcement as an array in parameter 2, but in this situation we don't care.
                {
                    _view.change(item.key, item.value, item.displayValue, item.dataType, _internal.isPrompt(item.value), item.required);
                },
                "add": function (item) // , length)
                {
                    var addToInUseItems = this === _unsavedModel;
                    _view.add(addToInUseItems, item.key, item.value, item.displayValue, item.dataType, _internal.isPrompt(item.value), item.required);
                },
                "remove": function (item) // , index)
                {
                    _view.remove(item.key);
                }
            },
            view: {
                closed: {
                    "open": function ()
                    {
                        _self.stopObservingEvent(_view, _events.view.closed);
                        _self.observe(_view, _events.view.open);

                        _unsavedModel = _internal.makeSearchParameterCollection(_savedModel);
                        _availableModel = skyward.mvvm.newModelCollection();
                        _viewState = skyward.mvvm.newModel({ selected: null, errors: {} });

                        _self.observe(_unsavedModel, _events.model);
                        _self.observe(_availableModel, _events.model);
                        _self.observe(_viewState, _events.viewState);

                        // clone saved model into unsaved model, which will display each entry in the builder
                        _savedModel.forEach(function (d) { _unsavedModel.add(_internal.cloneSearchParameter(d)); });

                        if (_unsavedModel.length)
                        {
                            _viewState.selected = _unsavedModel.elementAt(0);
                        }

                        _internal.loadAvailableItems();
                    }
                },
                open: {
                    "add": function ()
                    {
                        var item = _viewState.selected;
                        _viewState.selected = null;
                        _availableModel.remove(item);

                        _unsavedModel.add(item);
                        _viewState.selected = item;
                    },
                    "remove": function ()
                    {
                        var item = _viewState.selected;
                        if (!item.required)
                        {
                            _viewState.selected = null;
                            _unsavedModel.remove(item);

                            _availableModel.add(item);
                            _viewState.selected = item;
                            item.value = "";
                            item.displayValue = "";
                        }
                    },
                    "select": function (inUse, index)
                    {
                        _viewState.selected = (inUse ? _unsavedModel : _availableModel).elementAt(index);
                    },
                    "change": function (inUse, index, value, displayValue)
                    {
                        var item = (inUse ? _unsavedModel : _availableModel).elementAt(index);
                        item.displayValue = displayValue;
                        item.value = value;
                        if (_viewState.errors[item.key])
                        {
                            delete _viewState.errors[item.key];
                            _view.Validate();
                        }
                    },
                    "save": function ()
                    {
                        var matchedKeys = [];
                        var added = [];
                        var deleted = [];
                        _viewState.errors = {};

                        _savedModel.massUpdateInProgress = true;

                        // Merge values that were changed into the saved/live model
                        _savedModel.forEach(function (savedItem)
                        {
                            // savedItem.key becomes the second parameter of each delegate call
                            var matchingUnsavedItem = _unsavedModel.find(function (p, k) { return p.key === k; }, savedItem.key);
                            if (matchingUnsavedItem)
                            {
                                let validatedResult = _internal.validateValue(matchingUnsavedItem);
                                if (!validatedResult.isValid)
                                {
                                    _viewState.errors[savedItem.key] = [validatedResult.errorMessage];
                                }
                                else
                                {
                                    savedItem.value = matchingUnsavedItem.value;
                                    savedItem.displayValue = matchingUnsavedItem.displayValue;
                                    savedItem.required = matchingUnsavedItem.required;
                                    savedItem.isList = matchingUnsavedItem.isList;
                                    matchedKeys[savedItem.key] = true;
                                }
                            }
                            else
                            {
                                deleted.push(savedItem);
                            }
                        });
                        // Identify new parameters that were added during this popup session and add them to the saved/live model
                        _unsavedModel.forEach(function (unsavedItem)
                        {
                            if (!matchedKeys[unsavedItem.key])
                            {
                                let validatedResult = _internal.validateValue(unsavedItem);
                                if (!validatedResult.isValid)
                                {
                                    _viewState.errors[unsavedItem.key] = [validatedResult.errorMessage];
                                }
                                else
                                {
                                    added.push(unsavedItem);
                                }
                            }
                        });
                        added.forEach(_savedModel.add);
                        // Remove deleted parameters from saved/live model
                        deleted.forEach(_savedModel.remove);

                        _savedModel.massUpdateInProgress = false;
                    },
                    "close": function ()
                    {
                        _self.stopObservingEverything();
                        _self.observe(_view, _events.view.closed);
                        _self.observe(skyward.reporting.prompts.promptCollection, _events.prompts);
                    },
                    "dynamicValues": function (index)
                    {
                        const searchParameter = _unsavedModel.elementAt(index);

                        const validPrompts = skyward.reporting.prompts.promptCollection.findMany(function (prompt)
                        {
                            const parameter = skyward.reporting.currentReportDefinition.AvailableParameters[searchParameter.key];
                            const promptIsSameInputType = prompt.InputType === searchParameter.dataType;
                            const parameterAcceptsPromptType = parameter.isList === (prompt.Type === skyward.reporting.enummaps.PromptTypes.MultipleSelect);
                            return promptIsSameInputType && parameterAcceptsPromptType;
                        });

                        $.ajax({
                            url: skyward.global.virtualDir + "Reporting/Report/GetParameterOptionsByDataType",
                            type: "POST",
                            dataType: "JSON",
                            data: { dataType: searchParameter.dataType, isList: searchParameter.isList }
                        }).then(function (data)
                        {
                            _view.showDynamicValues(searchParameter, validPrompts, data.environmentValues, data.enumOptions);
                        });
                    }
                }
            },
            prompts: {
                "add": function (promptModel)
                {
                    _internal.updatePromptDisplayValues(promptModel.PromptUniqueId, promptModel.Label);
                },
                "model:Label": function (promptModel)
                {
                    _internal.updatePromptDisplayValues(promptModel.PromptUniqueId, promptModel.Label);
                },
                "delete": function (promptModel)
                {
                    _internal.removePromptReferences(promptModel.PromptUniqueId);
                }
            }
        };

        var exposedActions = {
            "toggleButton": function ()
            {
                $(".jsSearchParameterBuilder").toggle(!jQuery.isEmptyObject(skyward.reporting.currentReportDefinition.AvailableParameters));
            },
            "mergeAdd": function (parameters, parameterToAdd)
            {
                if (parameters && parameterToAdd)
                {
                    if (parameters.hasOwnProperty(parameterToAdd.key))
                    {
                        parameters[parameterToAdd.key].required = parameters[parameterToAdd.key].required || parameterToAdd.required;
                    }
                    else
                    {
                        parameters[parameterToAdd.key] = parameterToAdd;
                    }
                }
            },
            "init": function (savedData)
            {
                // Designer uses inline js to fire "init", and this gets triggered on *save*, not just on full-page load,
                //  so currently we can hit this code unexpectedly, when old listeners are already registered.
                _self.stopObservingEverything();

                var savedModels = [];
                (savedData || {}).forEach(function (data)
                {
                    savedModels.push(_internal.makeSearchParameter(data));
                });

                skyward.reporting.searchParameters.model = _savedModel = _internal.makeSearchParameterCollection(savedModels);

                _view.init();
                _self.observe(_view, _events.view.closed);
                _self.observe(skyward.reporting.prompts.promptCollection, _events.prompts);
                return;
            },
            "getErrors": function ()
            {
                return _viewState.errors;
            }
        };
        return exposedActions;
    });
})(skyward || {}, window.jQuery);

